(function () {
  "use strict";

  var root = document.querySelector("[data-mindelor-travel-app]");
  var figure = document.querySelector("[data-destination-hero]");
  if (!root || !figure) return;

  var switcher = figure.querySelector("[data-destination-media-switch]");
  var photoPanel = figure.querySelector("[data-destination-photo-panel]");
  var photoCaption = figure.querySelector("[data-destination-photo-caption]");
  var livePanel = figure.querySelector("[data-destination-live-panel]");
  var liveStage = figure.querySelector("[data-destination-live-stage]");
  var liveMessage = figure.querySelector("[data-destination-live-message]");
  var liveLocation = figure.querySelector("[data-destination-live-location]");
  var liveTime = figure.querySelector("[data-destination-live-time]");
  var liveBadge = figure.querySelector("[data-destination-live-badge]");
  var liveSource = figure.querySelector("[data-destination-live-source]");
  var stopButton = figure.querySelector("[data-destination-live-stop]");
  var tabs = Array.prototype.slice.call(figure.querySelectorAll("[data-destination-media-tab]"));
  if (!switcher || !photoPanel || !livePanel || !liveStage || tabs.length !== 2) return;

  var activeMode = "photo";
  var activeConfig = null;
  var activeContext = {};
  var activePlayer = null;
  var playerRequest = 0;
  var resolveRequest = 0;
  var timeTimer = null;
  var youtubeApiPromise = null;
  var resolvedSources = Object.create(null);

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function safeHttpsUrl(value, fallback) {
    try {
      var url = new URL(String(value || ""));
      return url.protocol === "https:" ? url.toString() : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function youtubeVideoId(value) {
    var id = String(value || "").trim();
    return /^[A-Za-z0-9_-]{11}$/.test(id) ? id : "";
  }

  function windyWebcamsUrl() {
    return "https://www.windy.com/webcams";
  }

  function exactContext(value) {
    var context = value && typeof value === "object" ? value : {};
    var coordinates = context.coordinates && typeof context.coordinates === "object" ? context.coordinates : {};
    var latitude = Number(coordinates.lat);
    var longitude = Number(coordinates.lon);
    return {
      country: String(context.country || "").trim(),
      timeZone: String(context.timeZone || "").trim(),
      latitude: Number.isFinite(latitude) ? latitude : null,
      longitude: Number.isFinite(longitude) ? longitude : null
    };
  }

  function destinationConfig(destination, context) {
    var name = String(destination || "").trim();
    if (root.getAttribute("data-mindelor-live-view-enabled") !== "true" || !name) return null;

    var normalizedDestination = normalize(name);
    var cached = resolvedSources[normalizedDestination];
    if (cached) return Object.assign({}, cached, { destination: name, timeZone: context.timeZone || cached.timeZone || "" });

    if (/\b(new york|new york city|manhattan)\b/.test(normalizedDestination)) {
      var videoId = youtubeVideoId(root.getAttribute("data-mindelor-live-new-york-video-id"));
      if (videoId) {
        return {
          key: "curated:new-york-times-square:" + videoId,
          destination: name,
          kind: "youtube",
          videoId: videoId,
          embedUrl: "",
          location: String(root.getAttribute("data-mindelor-live-new-york-location") || "Times Square").trim(),
          provider: String(root.getAttribute("data-mindelor-live-new-york-provider") || "Externe livebron").trim(),
          sourceUrl: safeHttpsUrl(
            root.getAttribute("data-mindelor-live-new-york-source-url"),
            "https://www.youtube.com/watch?v=" + videoId
          ),
          timeZone: context.timeZone || "America/New_York",
          automatic: false
        };
      }
    }

    return {
      key: "automatic:" + normalizedDestination,
      destination: name,
      kind: "automatic",
      videoId: "",
      embedUrl: "",
      location: name,
      provider: "Windy Webcams + YouTube",
      sourceUrl: windyWebcamsUrl(),
      timeZone: context.timeZone,
      automatic: true
    };
  }

  function setLiveState(state) {
    livePanel.setAttribute("data-live-state", state);
    if (!liveBadge) return;
    var labels = {
      ready: "Broncontrole",
      loading: "Controleren",
      playing: "Live",
      offline: "Geen livebron"
    };
    liveBadge.textContent = labels[state] || labels.ready;
  }

  function updateLocalTime() {
    if (!activeConfig || !liveTime) return;
    if (!activeConfig.timeZone) {
      liveTime.textContent = "Lokale tijdzone niet bevestigd";
      return;
    }
    try {
      var value = new Intl.DateTimeFormat("nl-NL", {
        timeZone: activeConfig.timeZone,
        hour: "2-digit",
        minute: "2-digit",
        timeZoneName: "short"
      }).format(new Date());
      liveTime.textContent = "Lokale tijd " + value;
    } catch (error) {
      liveTime.textContent = "Lokale tijdzone niet bevestigd";
    }
  }

  function startLocalClock() {
    window.clearInterval(timeTimer);
    updateLocalTime();
    timeTimer = window.setInterval(updateLocalTime, 30000);
  }

  function stopLocalClock() {
    window.clearInterval(timeTimer);
    timeTimer = null;
  }

  function promptMarkup(message, detail) {
    return (
      '<div class="mindelor-destination-live__prompt">' +
        '<span class="mindelor-destination-live__play" aria-hidden="true"></span>' +
        '<strong>' + message + '</strong>' +
        '<small>' + detail + '</small>' +
      '</div>'
    );
  }

  function resetPrompt() {
    liveStage.innerHTML = promptMarkup(
      "Bekijk de bestemming zoals het er nu uitziet.",
      "MINDELOR controleert de bron pas nadat je Live bekijken kiest."
    );
  }

  function destroyPlayer(resetStage) {
    playerRequest += 1;
    if (activePlayer && typeof activePlayer.destroy === "function") {
      try { activePlayer.destroy(); } catch (error) {}
    }
    activePlayer = null;
    if (stopButton) stopButton.hidden = true;
    if (resetStage) resetPrompt();
    setLiveState("ready");
  }

  function setSourceDetails() {
    if (!activeConfig) return;
    if (liveLocation) liveLocation.textContent = activeConfig.location || activeConfig.destination;
    if (liveSource) {
      liveSource.href = activeConfig.sourceUrl || windyWebcamsUrl();
      liveSource.textContent = activeConfig.embedUrl
        ? "Webcam via Windy.com · open bron"
        : activeConfig.videoId
          ? "Open bron · " + activeConfig.provider
          : "Bekijk webcams op Windy.com";
    }
    updateLocalTime();
  }

  function showUnavailable(message, serviceUnavailable) {
    destroyPlayer(false);
    if (activeConfig && activeConfig.automatic) {
      var failedDestination = activeConfig.destination;
      delete resolvedSources[normalize(failedDestination)];
      activeConfig = destinationConfig(failedDestination, activeContext);
      setSourceDetails();
    }
    setLiveState("offline");
    liveStage.innerHTML =
      '<div class="mindelor-destination-live__fallback" role="status">' +
        '<strong>' + (serviceUnavailable ? 'Live bekijken is nog niet beschikbaar.' : 'Geen bevestigde livecamera beschikbaar.') + '</strong>' +
        '<p>' + (serviceUnavailable ? 'Je kunt de bestemmingsfoto bekijken en gewoon verder met je reisvoorbereiding.' : 'Camera’s kunnen ontbreken, offline staan of insluiten blokkeren. De bestemmingsfoto blijft altijd beschikbaar.') + '</p>' +
        '<div>' +
          (serviceUnavailable ? '' : '<button type="button" data-destination-live-retry>Opnieuw controleren</button>') +
          '<button type="button" data-destination-live-photo>Bekijk foto</button>' +
        '</div>' +
      '</div>';
    if (liveMessage) liveMessage.textContent = message;
  }

  function serviceEndpoint() {
    return String(root.getAttribute("data-mindelor-service-endpoint") || "").replace(/\/+$/, "");
  }

  function resolveLiveSource() {
    if (!activeConfig || activeConfig.videoId) return Promise.resolve(activeConfig);
    var endpoint = serviceEndpoint();
    if (!endpoint) return Promise.reject(new Error("live_service_unconfigured"));

    var requestUrl = new URL(endpoint + "/destination-live", window.location.origin);
    requestUrl.searchParams.set("destination", activeConfig.destination);
    if (activeConfig.timeZone) requestUrl.searchParams.set("timeZone", activeConfig.timeZone);
    if (activeContext.latitude !== null) requestUrl.searchParams.set("lat", String(activeContext.latitude));
    if (activeContext.longitude !== null) requestUrl.searchParams.set("lon", String(activeContext.longitude));

    var request = ++resolveRequest;
    var expectedKey = activeConfig.key;
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 10000);
    return window.MindelorCustomerStorage.fetch(requestUrl.toString(), {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      signal: controller.signal
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (response.status === 503 || payload.availability === "not_configured") throw new Error("live_service_unconfigured");
          if (!response.ok) throw new Error(payload.error || "live_source_status_" + response.status);
          return payload;
        });
      })
      .then(function (payload) {
        if (request !== resolveRequest || !activeConfig || activeConfig.key !== expectedKey) throw new Error("live_source_stale");
        if (payload.availability === "unavailable") throw new Error("live_source_unavailable");
        var id = youtubeVideoId(payload.videoId);
        var embedUrl = safeHttpsUrl(payload.embedUrl, "");
        var kind = payload.kind === "windy" && embedUrl ? "windy" : id ? "youtube" : "";
        if (payload.availability !== "available" || !kind) throw new Error("live_source_not_found");
        var resolved = {
          key: "resolved:" + normalize(activeConfig.destination) + ":" + (id || embedUrl),
          destination: activeConfig.destination,
          kind: kind,
          videoId: id,
          embedUrl: embedUrl,
          location: String(payload.location || activeConfig.destination).trim(),
          provider: String(payload.provider || "Externe livebron").trim(),
          sourceUrl: safeHttpsUrl(payload.sourceUrl, id ? "https://www.youtube.com/watch?v=" + id : windyWebcamsUrl()),
          timeZone: String(payload.timeZone || activeConfig.timeZone || "").trim(),
          automatic: true
        };
        resolvedSources[normalize(resolved.destination)] = resolved;
        activeConfig = resolved;
        setSourceDetails();
        return resolved;
      })
      .finally(function () { window.clearTimeout(timeout); });
  }

  function loadYouTubeApi() {
    if (window.YT && typeof window.YT.Player === "function") return Promise.resolve(window.YT);
    if (youtubeApiPromise) return youtubeApiPromise;

    youtubeApiPromise = new Promise(function (resolve, reject) {
      var settled = false;
      var previousReady = window.onYouTubeIframeAPIReady;
      var timeout = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error("youtube_api_timeout"));
      }, 15000);

      window.onYouTubeIframeAPIReady = function () {
        if (typeof previousReady === "function") {
          try { previousReady(); } catch (error) {}
        }
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        if (window.YT && typeof window.YT.Player === "function") resolve(window.YT);
        else reject(new Error("youtube_api_missing"));
      };

      var script = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
      if (!script) {
        script = document.createElement("script");
        script.src = "https://www.youtube.com/iframe_api";
        script.async = true;
        document.head.appendChild(script);
      }
      script.addEventListener("error", function () {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        reject(new Error("youtube_api_failed"));
      }, { once: true });
    }).catch(function (error) {
      youtubeApiPromise = null;
      throw error;
    });

    return youtubeApiPromise;
  }

  function startPlayer() {
    if (!activeConfig || (!activeConfig.videoId && !activeConfig.embedUrl) || activeMode !== "live") return;
    destroyPlayer(false);
    var request = ++playerRequest;
    var playerId = "mindelor-destination-live-player-" + Date.now();

    setLiveState("loading");
    if (activeConfig.kind === "windy" && activeConfig.embedUrl) {
      var iframe = document.createElement("iframe");
      var iframeTimeout = window.setTimeout(function () {
        if (request === playerRequest && activeMode === "live") {
          showUnavailable("De gecontroleerde webcam reageerde niet op tijd. De foto blijft beschikbaar.");
        }
      }, 15000);
      iframe.className = "mindelor-destination-live__player";
      iframe.src = activeConfig.embedUrl;
      iframe.title = "Livecamera van " + activeConfig.location;
      iframe.loading = "eager";
      iframe.referrerPolicy = "strict-origin-when-cross-origin";
      iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
      iframe.setAttribute("allowfullscreen", "");
      iframe.addEventListener("load", function () {
        if (request !== playerRequest || activeMode !== "live") return;
        window.clearTimeout(iframeTimeout);
        setLiveState("playing");
        if (stopButton) stopButton.hidden = false;
        if (liveMessage) liveMessage.textContent = "Live webcam via Windy. Beschikbaarheid blijft afhankelijk van de externe camera.";
      }, { once: true });
      iframe.addEventListener("error", function () {
        window.clearTimeout(iframeTimeout);
        if (request === playerRequest && activeMode === "live") {
          showUnavailable("De gecontroleerde webcam kon niet worden geopend. De foto blijft beschikbaar.");
        }
      }, { once: true });
      liveStage.replaceChildren(iframe);
      activePlayer = {
        destroy: function () {
          window.clearTimeout(iframeTimeout);
          iframe.remove();
        }
      };
      if (liveMessage) liveMessage.textContent = "Live webcam wordt veilig verbonden via Windy Webcams…";
      return;
    }

    liveStage.innerHTML = '<div id="' + playerId + '" class="mindelor-destination-live__player"></div>';
    liveStage.querySelector("#" + playerId).setAttribute("aria-label", "Livebeeld van " + activeConfig.location);
    if (liveMessage) liveMessage.textContent = "Livebeeld wordt veilig verbonden via " + activeConfig.provider + "…";

    loadYouTubeApi()
      .then(function (YT) {
        if (request !== playerRequest || activeMode !== "live" || !activeConfig) return;
        var expectedKey = activeConfig.key;
        var playerVars = {
          autoplay: 1,
          controls: 1,
          playsinline: 1,
          rel: 0,
          fs: 1
        };
        if (/^https?:$/.test(window.location.protocol)) playerVars.origin = window.location.origin;
        activePlayer = new YT.Player(playerId, {
          host: "https://www.youtube-nocookie.com",
          videoId: activeConfig.videoId,
          playerVars: playerVars,
          events: {
            onReady: function (event) {
              if (!activeConfig || activeConfig.key !== expectedKey || activeMode !== "live") {
                try { event.target.destroy(); } catch (error) {}
                return;
              }
              try {
                event.target.mute();
                event.target.playVideo();
              } catch (error) {}
              if (stopButton) stopButton.hidden = false;
              if (liveMessage) liveMessage.textContent = "Speler gereed. Geluid staat standaard uit.";
            },
            onStateChange: function (event) {
              if (event.data !== YT.PlayerState.PLAYING || !activeConfig || activeConfig.key !== expectedKey) return;
              setLiveState("playing");
              if (liveMessage) liveMessage.textContent = "Live vanuit " + activeConfig.location + ". Geluid staat standaard uit.";
            },
            onError: function () {
              window.setTimeout(function () {
                if (activeMode === "live") showUnavailable("De gecontroleerde bron is offline of blokkeert insluiten. De foto blijft beschikbaar.");
              }, 0);
            }
          }
        });
      })
      .catch(function () {
        if (request === playerRequest && activeMode === "live") {
          showUnavailable("De externe videospeler kon niet worden geladen. De foto blijft beschikbaar.");
        }
      });
  }

  function startLive() {
    if (!activeConfig || activeMode !== "live") return;
    if (activeConfig.videoId || activeConfig.embedUrl) {
      startPlayer();
      return;
    }

    destroyPlayer(false);
    setLiveState("loading");
    liveStage.innerHTML = promptMarkup(
      "Een actuele bron wordt gecontroleerd.",
      "Alleen een actieve, insluitbare camera die bij deze locatie past wordt geopend."
    );
    if (liveMessage) liveMessage.textContent = "Livecamera voor " + activeConfig.destination + " controleren…";
    resolveLiveSource()
      .then(function () {
        if (activeMode === "live") startPlayer();
      })
      .catch(function (error) {
        if (error && error.message === "live_source_stale") return;
        if (activeMode === "live") {
          var serviceUnavailable = error && error.message === "live_service_unconfigured";
          var message = serviceUnavailable
            ? "Live bekijken is nog niet beschikbaar. Je bestemmingsfoto blijft beschikbaar."
            : error && error.message === "live_source_not_found"
              ? "Er is nu geen gecontroleerde, insluitbare camera voor deze locatie gevonden."
              : "De livebron kan tijdelijk niet worden gecontroleerd. Probeer het later opnieuw of bekijk de foto.";
          showUnavailable(message, serviceUnavailable);
        }
      });
  }

  function renderMode(startStream) {
    var showLive = activeMode === "live" && Boolean(activeConfig);
    photoPanel.hidden = showLive;
    if (photoCaption) photoCaption.hidden = showLive;
    livePanel.hidden = !showLive;

    tabs.forEach(function (tab) {
      var selected = tab.getAttribute("data-destination-media-tab") === activeMode;
      tab.setAttribute("aria-selected", selected ? "true" : "false");
      tab.setAttribute("tabindex", selected ? "0" : "-1");
      tab.classList.toggle("is-active", selected);
    });

    if (showLive) {
      startLocalClock();
      if (startStream) startLive();
      return;
    }

    stopLocalClock();
    destroyPlayer(true);
    if (liveMessage) liveMessage.textContent = "Kies Live bekijken om een actuele bron te controleren.";
  }

  function setMode(mode, startStream) {
    activeMode = mode === "live" && activeConfig ? "live" : "photo";
    renderMode(Boolean(startStream));
  }

  function sync(destination, context) {
    activeContext = exactContext(context);
    var nextConfig = destinationConfig(destination, activeContext);
    resolveRequest += 1;
    if (!nextConfig) {
      activeConfig = null;
      figure.removeAttribute("data-destination-live-ready");
      switcher.hidden = true;
      setMode("photo", false);
      return false;
    }

    var sameConfig = activeConfig && activeConfig.key === nextConfig.key;
    activeConfig = nextConfig;
    figure.setAttribute("data-destination-live-ready", "true");
    switcher.hidden = false;
    figure.hidden = false;
    setSourceDetails();

    if (!sameConfig) setMode("photo", false);
    return true;
  }

  switcher.addEventListener("click", function (event) {
    var tab = event.target.closest("[data-destination-media-tab]");
    if (!tab) return;
    var mode = tab.getAttribute("data-destination-media-tab");
    setMode(mode, mode === "live");
  });

  switcher.addEventListener("keydown", function (event) {
    var tab = event.target.closest("[data-destination-media-tab]");
    if (!tab || ["ArrowLeft", "ArrowRight", "Home", "End"].indexOf(event.key) === -1) return;
    event.preventDefault();
    var currentIndex = tabs.indexOf(tab);
    var nextIndex = event.key === "Home" ? 0 : event.key === "End" ? tabs.length - 1 :
      (currentIndex + (event.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length;
    tabs[nextIndex].focus();
    tabs[nextIndex].click();
  });

  livePanel.addEventListener("click", function (event) {
    if (event.target.closest("[data-destination-live-retry]")) startLive();
    if (event.target.closest("[data-destination-live-photo]")) setMode("photo", false);
    if (event.target.closest("[data-destination-live-stop]")) {
      destroyPlayer(true);
      if (liveMessage) liveMessage.textContent = "Livebeeld gestopt. Je kunt het opnieuw openen of teruggaan naar de foto.";
    }
  });

  window.addEventListener("pagehide", function () { destroyPlayer(false); });

  window.MindelorDestinationLive = Object.freeze({
    sync: sync,
    stop: function () { setMode("photo", false); }
  });
}());
